/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：hC2z
 */

export enum EWorkType {
  CREATE = "CREATE",
  COLL = "COLL",
  HOME = "HOME",
  DELETE = "DELETE"
}
